import React from 'react';
import { DealOfTheDayTag, DealOfTheDayTimerTag } from './DodCommonComponent';

export default function DodTimer({ dodEndTime, deviceType = '' }) {
  return (
    <div className="dealOfDay">
      {deviceType !== 'mobile' && <DealOfTheDayTag />}
      {
        <DealOfTheDayTimerTag
          imagePath={`${
            deviceType === 'mobile'
              ? '/static/img/timerMobileProduct.png'
              : '/static/img/endsIn.png'
          }`}
          alt="Timer icon"
          dealOfTheDayProductTimer={dodEndTime}
          deviceType={deviceType}
        />
      }
    </div>
  );
}
